import { render, staticRenderFns } from "./ReviewsCarousel.vue?vue&type=template&id=de6e948c&"
import script from "./ReviewsCarousel.vue?vue&type=script&lang=js&"
export * from "./ReviewsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports